import SrView from "./SrView.vue";

SrView.install = function(Vue) {
  Vue.component(SrView.name, SrView);
};

export default SrView;



// WEBPACK FOOTER //
// ./packages/SrView/index.js